import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faEye } from "@fortawesome/free-solid-svg-icons";
function Marketactive() {
  const [product, setProduct] = useState([]);
  const [search, setSearch] = useState([""]);
  const [show, setShow] = useState(false);
  const [view, setView] = useState();
  const getProductData = async () => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/marketer/active`);

      console.log(data.data);
      setProduct(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getProductData();
  }, []);

  const getMarkDataView = async (id) => {
    setShow(true);
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/marketer/active/view/`+id
      );
      console.log("check", data.data.data);
      setView(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getMarkDeactivate = (id) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/admin/marketer/deactivate/`+id, {
        dmr_id: id,
      })
      .then(function (response) {
        if (response.data.status === 200) {
          alert("Deactivated");
          getProductData();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <h2>Active Marketer List</h2>
      <div className="text-end">
      <input
        type="text"
        placeholder="search here"
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
      </div>
      <div className="overflow-y-scroll px-5 py-3">
        <table className="table table-bordered border-primary table-hover ">
          <thead className="table-dark ">
            <tr>
              <th scope="col">S.NO</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Company</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {product.data !== undefined
              ? product.data
                  .filter((item) => {
                    if (search === "") {
                      return item;
                    } else if (item.email.includes(search)) {
                      return item;
                    }
                  })
                  .map((item, index) => {
                    return (
                      <tr>
                        <th scope="row">{index}</th>
                        <td>{item.firstname + item.lastname}</td>
                        <td>{item.email}</td>
                        <td>{item.mobile}</td>
                        <td>{item.company}</td>
                        <td>
                          <FontAwesomeIcon
                            icon={faEye}
                            title="view"
                            style={{ color: "#044389" }}
                            onClick={() => getMarkDataView(item.dmr_id)}
                          />{" "}
                          <FontAwesomeIcon
                            icon={faBan}
                            title="Deactivate"
                            style={{ color: "#FF0000" }}
                            onClick={() => getMarkDeactivate(item.dmr_id)}
                          />{" "}
                        </td>
                      </tr>
                    );
                  })
              : null}
          </tbody>
        </table>
        <Modal show={show} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Active Marketer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {console.log("view", view)} */} 
          {view !== undefined ? (
          <div className="overflow-y-scroll px-5 py-3">
            <table className="table table-bordered border-primary table-hover ">
              <thead className="table-dark ">
                <tr>
                  <th scope="col">S.NO</th>
                  <th scope="col">Publisher Name</th>
                  <th scope="col">Posted Date</th>
                  <th scope="col">Title</th>
                </tr>
              </thead>
              <tbody>
                {view !== undefined ? (
                  view.map((item, index) => (
                    <>
                      <tr>
                        <th scope="row">{index}</th>
                        <td>{item.publisher_firstname + item.publisher_lastname}</td>
                        <td>{item.posted_date}</td>
                        <td>{item.title}</td>
                      </tr>
                    </>
                  ))
                ) : (
                
                 <></>
                )}
                
              
              </tbody>
            </table>

          </div>
          ):(
            <> <p> No Records Found</p></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </>
  );
}
export default Marketactive;
